import { API, ProductType } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  page?: number;
  limit?: number;
  sort?: string;
};

export type ProductTypesResult = {
  productTypes: ProductType[];
  total: number;
};

type NormalizedResult = {
  productTypes: number[];
  total: number;
};

const [useProductTypes, fetchProductTypes] = createQueryAction<
  Args,
  ProductTypesResult,
  NormalizedResult
>(
  {
    entity: "productTypes",
    action: "fetchProductTypes",
    condition: ({ args }) => Boolean(args.spaceId),
    denormalize: { entity: null, productTypes: "productTypes" },
    pagingKey: "productTypes",
  },
  async ({ args }) => {
    const res = await API.call<{ productTypes: number[]; total: number }>({
      endpoint: `spaces/${args.spaceId}/product-types`,
      method: "GET",
      query: {
        page: args.page,
        limit: args.limit,
        sort: args.sort,
      },
    });
    return res;
  }
);

export default useProductTypes;
export { fetchProductTypes };
